<mat-card>
  <mat-card-header *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
      >{{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
    <button
      mat-icon-button
      *ngIf="mediaItem"
      icon="more_vert"
      [matTooltip]="'common.options' | t"
      matTooltipPosition="before"
      [matMenuTriggerFor]="mediaOptions"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  </mat-card-header>
  <ng-container *ngIf="!mediaItem || changeMedia; else mediaTmpl">
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <mat-card-content>
        <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-flat-button
          type="submit"
          color="success"
          [disabled]="!form.value.files"
          (isLoading)="(isLoading)"
        >
          {{ 'common.upload' | t }}
        </button>
      </mat-card-actions>
    </form>
  </ng-container>

  <ng-template #mediaTmpl>
    <ng-container *ngIf="isImage">
      <img class="widgetMedia" style="width: 100%" [src]="mediaItem.file" alt="Media" />
    </ng-container>
    <ng-container *ngIf="isPdf">
      <canvas id="canvasEl"></canvas>
      <div *ngIf="file.numPages">
        <button mat-button (click)="previousPdfPage()" [disabled]="pdfPage === 1">{{ 'common.previous' | t }}</button>
        <button mat-button (click)="nextPdfPage()" [disabled]="pdfPage === file.numPages">
          {{ 'common.next' | t }}
        </button>
      </div>
    </ng-container>
  </ng-template>
</mat-card>

<mat-menu #mediaOptions="matMenu">
  <button mat-menu-item *ngIf="canChange && mediaItem" (click)="toggleMediaUpload()">
    <sn-icon>upload</sn-icon>
    <span>{{ 'common.upload' | t }}</span>
  </button>
  <button mat-menu-item *ngIf="canView && mediaItem" (click)="download()">
    <sn-icon>download</sn-icon>
    <span>{{ 'common.download' | t }}</span>
  </button>
  <button
    mat-menu-item
    *ngIf="canChange && mediaItem && widgetMedia.length"
    [matMenuTriggerFor]="mediaMenu"
  >
    <sn-icon>swap_horiz</sn-icon>
    <span>{{ 'dashboard.operational.widgets.changeMedia' | t }}</span>
  </button>
  <button color="danger" mat-menu-item *ngIf="canDelete && mediaItem" (click)="remove()">
    <sn-icon>delete</sn-icon>
    <span>{{ 'common.delete' | t }}</span>
  </button>
</mat-menu>

<mat-menu #mediaMenu="matMenu">
  <button mat-menu-item *ngFor="let media of widgetMedia" (click)="select(media)">
    <sn-icon>description</sn-icon>
    <span>{{ media.description }}</span>
  </button>
</mat-menu>

<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
